export default __webpack_public_path__ + "static/media/about.c09c8008.png";